import React, { Component } from "react";
import track from "../lib/tracking";
import _ from "lodash";
import Button from "../elements/Button";

class SubscribeForm extends Component {
  state = {
    email: ""
  };
  handleChange = (param, value) => {
    this.setState({ [param]: value });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if(!this.validateEmail(this.state.email)){
      return;
    }
    this.props.onFormSubmit(this.state)
  }
  validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    return (
      <div className="subscribe-form">
        <form onSubmit={this.handleSubmit}>
          <div>Thanks for using Counter Programming. We would like to keep you informed on how we develop this tool. Please enter your email address to register your interest and to keep using it.</div>
          <label>
            Email:
            <input type="text" value={this.state.email} onChange={e => this.handleChange("email",e.target.value)} />
          </label>
          <input className="submit-button" type="submit" value="Submit" />
        </form>
      </div>
    );
  }
}

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/components/SubscribeForm.js